/**
 * Main campaign — OmniGive embed (paste from Donorbox Share & Embed → OmniGive → Copy Code)
 */
export const LJCampaignUrl = `
<script type="module" src="https://donorbox.org/widgets.js" async></script>
<dbox-widget campaign="lineage-journey-1" type="donation_form" enable-auto-scroll="false"></dbox-widget>
`;

export const LJLanguageCampaignUrl = 'https://donorbox.org/embed/lineage-journey-1-2?language=en-us';
export const LJPopupCampaignUrl = 'https://donorbox.org/embed/lineage-journey-1-3?';
export const ReligiousLibertSeriesCampaign =
  'https://donorbox.org/embed/religious-liberty-series?hide_donation_meter=true';

//old embed code
// export const LJLanguageCampaignUrl = "https://donorbox.org/embed/lineage-journey-1-2?language=en-us";
// export const LJCampaignUrl = "https://donorbox.org/embed/lineage-journey-1?language=en-us"
// export const ReligiousLibertSeriesCampaign = "https://donorbox.org/embed/religious-liberty-series?hide_donation_meter=true"
